import { toast, type ExternalToast } from 'sonner';

export interface ToastOptions {
  description?: string;
  action?: {
    label: string;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  };
  cancel?: {
    label: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  };
  duration?: number;
}

export function useToast() {
  return {
    toast: {
      success: (message: string, options?: ToastOptions) =>
        toast.success(message, options as ExternalToast),
      error: (message: string, options?: ToastOptions) =>
        toast.error(message, options as ExternalToast),
      warning: (message: string, options?: ToastOptions) =>
        toast.warning(message, options as ExternalToast),
      info: (message: string, options?: ToastOptions) =>
        toast.info(message, options as ExternalToast),
      loading: (message: string, options?: ToastOptions) =>
        toast.loading(message, options as ExternalToast),
      promise: <T>(
        promise: Promise<T>,
        {
          loading,
          success,
          error,
        }: {
          loading: string;
          success: string | ((data: T) => string);
          error: string | ((error: any) => string);
        }
      ) => toast.promise(promise, { loading, success, error }),
      dismiss: (toastId?: string | number) => toast.dismiss(toastId),
    },
  };
}

export default useToast;
